<script lang="ts">
  import UIRouterLink from "@shared/svelte/Components/UIRouterLink.svelte";
  import type { UserInfo } from "@shared/types/User";
  import PageTitle from "@shared/svelte/Components/PageTitle.svelte";

  export let userInfo: UserInfo;
</script>

<PageTitle title="Welcome back - Sign up | Provi" />
<div data-grid-area="main" style="background: #F5F7F7">
  <div class="fizz-card fizz-inset-square-32 fizz-radius-medium fizz-elevation-1">
    <h2 class="fizz-heading-2 fizz-text-center fizz-stack-4">Welcome back,</h2>
    <p class="fizz-text-center fizz-stack-24 fizz-text-medium">
      {userInfo.email}
    </p>
    <p
      class="fizz-text-center fizz-radius-medium fizz-surface-gray fizz-inset-square-16 fizz-stack-32"
    >
      You're almost there! You started signing up for Provi and can finish by clicking the button
      below.
    </p>
    <UIRouterLink stateName="layout.signedIn.details" classes="fizz-underline-none">
      <button class="fizz-button-secondary fizz-full-width fizz-button-large fizz-stack-16">
        Finish signing up
      </button>
    </UIRouterLink>
    <p class="fizz-text-center">
      <a
        href={"#"}
        on:click={() => {
          window.location.href = "/users/fully_log_out";
        }}
      >
        Log out
      </a>
    </p>
  </div>
</div>
